// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3I4F-","row":"ProcedureTreatmentSummary_row__HeiYJ"};